import { TourStop } from './tour-stop';
import { ItemsByCategory } from './items-by-category';

/*
 * "TourData" : {
 *   "required" : ["id", "name", "endBarcode"],
 *   "type" : "object",
 *   "properties" : {
 *     "id" : {
 *       "description" : "Tour-ID",
 *       "type" : "string"
 *     },
 *     "name" : {
 *       "description" : "Tour-Name",
 *       "type" : "string"
 *     },
 *     "endBarcode" : {
 *       "description" : "Endbarcode der Tour",
 *       "type" : "string"
 *     }
 *   }
 * },
 */

export class Tour {
  public tourStops: TourStop[];
  public items: ItemsByCategory[];

  constructor(
    public id: string,
    public name: string,
    public endBarcode: string,
  ) { }

  /**
   * Initialize a Tour object from it's JSON representation (e.g. from an API)
   *
   * _The JSON object must have the properties (id, name, endBarcode) at it's first level, i.e. the first node should not
   * be `tour`, but it's contents._
   */
  public static fromJSON(json: {
    id: string,
    name: string,
    endBarcode: string,
  }): Tour {
    if (!json) {
      throw new Error('Tour JSON should not be undefined');
    }
    if (!json.id) {
      throw new Error('Tour JSON should have property: id');
    }
    if (!json.name) {
      throw new Error('Tour JSON should have property: name');
    }
    if (!json.endBarcode) {
      throw new Error('Tour JSON should have property: endBarcode');
    }

    return new Tour(
      json.id,
      json.name,
      json.endBarcode,
    );
  }

  public get json(): string {
    return JSON.stringify({
      id: this.id,
      name: this.name,
      endBarcode: this.endBarcode,
    });
  }
}
